import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const english = {
  全部内容: 'All items',
  收藏: 'Favorites',
  未整理: 'Unfiled',
  文件夹: 'Folders',
  标签: 'Tags',
  回收站: 'Trash',
  搜索内容: 'Search your library',
  新增: 'Save',
  设置: 'Settings',
  保存链接: 'Save a link',
  取消: 'Cancel',
  保存: 'Save',
  列表: 'List',
  卡片: 'Cards',
  瀑布流: 'Masonry',
  登录: 'Sign in',
  注册: 'Create account',
  邮箱: 'Email',
  密码: 'Password',
  名称: 'Name',
  退出登录: 'Sign out',
  管理: 'Manage',
  新建文件夹: 'New folder',
  新建标签: 'New tag',
  内容来源: 'Platform',
  全部来源: 'All platforms',
  保存状态: 'Capture status',
  全部状态: 'All states',
  选择: 'Select',
  取消选择: 'Cancel selection',
  加载更多: 'Load more',
  已显示全部内容: "You're all caught up",
  外观: 'Appearance',
  浅色: 'Light',
  深色: 'Dark',
  跟随系统: 'System',
  语言: 'Language',
  账户: 'Account',
  额度与存储: 'Usage and storage',
  已登录设备: 'Sessions',
  导入与导出: 'Import and export',
  管理后台: 'Administration',
  备注: 'Note',
  打开原文: 'Open original',
  移入文件夹: 'Move to folder',
  移入回收站: 'Move to trash',
  恢复: 'Restore',
  重新获取: 'Capture again',
  复制链接: 'Copy link',
  更多操作: 'More actions',
  返回内容库: 'Back to library',
  尚未保存内容: 'A home for what matters',
  '把值得留下的内容，放在这里。': 'Keep what matters, right here.',
  '粘贴链接，正文与图片会自动保存。': 'Paste a link to save its text and images.',
  继续阅读: 'Continue reading',
  加载失败: 'Unable to load',
  重试: 'Try again',
  重命名: 'Rename',
  删除: 'Delete',
  完成: 'Done',
};
void i18n.use(initReactI18next).init({
  resources: { 'zh-CN': { translation: {} }, en: { translation: english } },
  lng: 'zh-CN',
  fallbackLng: 'zh-CN',
  keySeparator: false,
  interpolation: { escapeValue: false },
});
export default i18n;
